import { Button, Modal, Row, Space, Spin, Typography } from "antd";
import { SessionStorage } from "../../services/storage";
import { PASSPORT_EXPIRY_MONTH } from "../../utils/app-common";
import { millisecondsToMinute } from "../../utils/luxon";
import { useLoginStore } from "../../stores/LoginStore";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { BiRefresh } from "react-icons/bi";

const RefreshComponent = () => {
	const GetMasterDetailAction = useLoginStore(
		(state) => state?.GetMasterDetailAction
	);
	const { promiseInProgress: masterProgress } = usePromiseTracker({
		area: "get-master-area",
	});

	const onGetMaster = () => {
		trackPromise(GetMasterDetailAction({ isRefresh: true }), "get-master-area");
	};
	return (
		<Row>
			<Spin spinning={masterProgress} size="default" tip="Loading Master">
				<Button
					type="primary"
					size="small"
					icon={<BiRefresh size={16} style={{ display: 'flex' }} />}
					onClick={onGetMaster}
					style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '0 6px' }}
				>
					Get Masters
				</Button>
			</Spin>
		</Row>
	);
};

function SettingComponent({ isOpen, setIsSetting }) {
	const timer = JSON.parse(SessionStorage.get('timer') || '');
	return (

		<Modal open={isOpen}
			onCancel={() => setIsSetting(false)}
			onOk={() => setIsSetting(false)}
			title='Settings' cancelButtonProps={{
				style: {
					display: 'none'
				}
			}}>
			<Row>
				<Space size={5} wrap direction='horizontal'>
					<Typography.Title level={5}>Logout Time :
						<Typography.Text> {millisecondsToMinute(timer)}</Typography.Text>
					</Typography.Title>
				</Space>
			</Row>
			<Row>
				<Space size={10}>
					<Typography.Title level={5}>Password Expiry :
						<Typography.Text> {PASSPORT_EXPIRY_MONTH} months</Typography.Text>
					</Typography.Title>
				</Space>
			</Row>
			<Row>
				<Space size={10}>
					<RefreshComponent />
				</Space>
			</Row>
		</Modal>
	)
}


export default SettingComponent
